import { Box, MenuItem, TextField, Typography } from "@mui/material";

import { capitalizeWord, formatRefreshTimestamp } from "./myPerformanceHelpers";

export default function MyPerformanceHeader({
  title = "My Dashboard",
  subtitle = "Monitor progress and trends across products and regions",
  options = [],
  value = "",
  onChange,
  disabled = false,
  /** When set (sales rep), replaces title/subtitle with greeting aligned to the product dropdown. */
  repGreetingFirstName,
  /** Raw API `refresh_timestamp` from the persona KPI payload. */
  refreshTimestamp = "",
}) {
  const formattedRefresh = formatRefreshTimestamp(refreshTimestamp);
  const showRepGreeting =
    typeof repGreetingFirstName === "string" &&
    repGreetingFirstName.trim().length > 0;

  return (
    <Box
      sx={{
        p: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        {showRepGreeting ? (
          <>
            <Typography
              sx={{
                fontSize: 22,
                fontWeight: 600,
                color: "#202020",
                lineHeight: 1.1,
              }}
            >
              Welcome back, {capitalizeWord(repGreetingFirstName)}
            </Typography>
            <Typography
              sx={{
                mt: 0.75,
                fontSize: 14,
                color: "#6F6F6F",
                lineHeight: 1.2,
              }}
            >
              {"Here's an overview of your performance and insights for today."}
            </Typography>
          </>
        ) : (
          <>
            <Typography
              sx={{
                fontSize: 22,
                fontWeight: 600,
                color: "#202020",
                lineHeight: 1.1,
              }}
            >
              {title}
            </Typography>

            <Typography
              sx={{
                mt: 0.75,
                fontSize: 14,
                color: "#6F6F6F",
                lineHeight: 1.2,
              }}
            >
              {subtitle}
            </Typography>
          </>
        )}
        {formattedRefresh ? (
          <Typography
            sx={{
              mt: 0.5,
              fontSize: 12,
              fontWeight: 600,
              color: "#D96B04",
              lineHeight: 1.2,
            }}
          >
            {`Auto-synced at ${formattedRefresh} EST`}
          </Typography>
        ) : null}
      </Box>

      {/* <TextField
        select
        size="small"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        disabled={disabled || !options?.length}
        sx={{
          width: 280,
          "& .MuiInputBase-root": {
            height: 40,
            borderRadius: 1,
            bgcolor: "#fff",
          },
        }}
        SelectProps={{
          inputProps: { "aria-label": "Dashboard filter" },
          displayEmpty: false,
        }}
      >
        {!options?.length ? (
          <MenuItem disabled value="">
            No options available
          </MenuItem>
        ) : (
          options.map((opt) => (
            <MenuItem key={opt} value={opt}>
              {opt}
            </MenuItem>
          ))
        )}
      </TextField> */}
    </Box>
  );
}
